import type {AdPreviewDataForList} from '@frontend/modules/public/ads/AdsModuleTypes'
import {AdPreviewPhotosSwiper} from '@frontend/modules/public/ads/components/list/AdPreviewPhotosSwiper'
import {mdiFire} from '@mdi/js'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'

interface AdsListItemImageAndIconsProps {
    ad: AdPreviewDataForList
}

// Картинка и иконки для карточки предпросмотра объявления в списке.
export function AdsListItemImage(props: AdsListItemImageAndIconsProps) {

    const {
        ad,
    } = props

    return (
        <div className="flex-center flex-shrink-0">
            <div className="offered-item-card-image-and-icons position-relative rounded-8 overflow-hidden">
                {ad.isPromoted && (
                    <div className="offered-item-card-promoted-label bg-orange rounded-end ps-1 pe-2 fs-7 with-icon-flex fw-500 text-dark">
                        <Icon
                            path={mdiFire}
                            size={20}
                            color="dark"
                        />
                        HOT!
                    </div>
                )}
                <AdPreviewPhotosSwiper
                    ad={ad}
                    noShadow
                />
                {ad.photos.length > 0 && (
                    // Для поисковиков.
                    <img
                        src={ad.photos[0]}
                        className="position-absolute opacity-0"
                        width={1}
                        height={1}
                        alt={ad.title}
                    />
                )}
            </div>
        </div>
    )
}
